import { Component, OnInit } from "@angular/core";
import { ProductService } from "src/app/core/services/product.service";
import { ActivatedRoute, Router } from "@angular/router";
import { environment } from "src/environments/environment";
import { CartService } from "src/app/core/services/cart.service";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-product",
  templateUrl: "./product.component.html",
  styleUrls: ["./product.component.css"],
})
export class ProductComponent implements OnInit {
  public urlHost = "";
  public product: any;
  public loading: boolean = true;
  typeMenu = 1;
  constructor(
    private productService: ProductService,
    private route: ActivatedRoute,
    private cartService: CartService,
    private toastrService: ToastrService,
    private router: Router
  ) {
    this.urlHost = environment.urlHostImage;
  }

  ngOnInit() {
    const codProducto = this.route.snapshot.params.id;
    this.getProduct(codProducto);
    this.getTypeMenu();
  }

  async getTypeMenu() {
    this.typeMenu = await this.productService.gettypeMenu();
  }

  getProduct(codProducto) {
    this.loading = true;
    this.productService.getProduct(codProducto).subscribe(
      (data) => {
        this.product = data;
        this.getValidate(this.product);
        this.loading = false;
      },
      (error) => {
        this.loading = false;
        console.log(error);
      }
    );
  }

  validaCheck(): boolean {
    if(this.product.maneja_modificadores == '0'){
      return true;
    }
    // Recorre todas las categorías de modificadores
    for (const category of this.product.modificadores) {
      let countSelect: number = 0; // Contador de selecciones en esta categoría
  
      // Recorre los modificadores de la categoría actual
      for (const modificador of category.modificadores) {
        if (modificador.seleccionado) {
          countSelect++;
        }
      }
  
      // Verifica las condiciones de mínimo y máximo
      if (category.minSeleccionado > 0 && countSelect < category.minSeleccionado) {
        this.toastrService.warning('Debes seleccionar un minimo: '+category.minSeleccionado+ " "+category.descripcion);
        return false; // No se cumple el mínimo, retorna falso
      }
  
      if (category.maxSeleccionado > 0 && countSelect > category.maxSeleccionado) {
        this.toastrService.warning('Debes seleccionar un maximo: '+category.minSeleccionado+ " "+category.descripcion);
        return false; // No se cumple el máximo, retorna falso
      }
    }
  
    return true; // Todas las categorías cumplen con los requisitos
  }

  getValidate(product: any) {
    if (!this.productService.getValidate(product)) {
      this.toastrService.info("El producto ya no se encuentra disponible");
      this.router.navigate(["/inicio"]);
    }
  }

  add() {
    this.product.cantidad += 1;
  }

  substract() {
    if (this.product.cantidad > 1) {
      this.product.cantidad -= 1;
    }
  }

  getTotal(): number {
    let total: number = 0;
    if (this.product) {
      total =
        (parseFloat(this.product.precio) + this.getExtras()) *
        this.product.cantidad;
    }
    return total;
  }

  getExtras(): number {
    let total: number = 0;
    if (this.product.maneja_modificadores == "1") {
      this.product.modificadores.forEach((element) => {
        element.modificadores.forEach((modificador) => {
          if (modificador.seleccionado && modificador.costo_adicional > 0) {
            total += parseFloat(modificador.costo_adicional);
          }
        });
      });
    }
    return total;
  }

  addCart() {
    if(!this.validaCheck()){
      return;
    }
    this.product.extras = this.getExtras();
    let result: boolean = this.cartService.addCart(this.product);
    if (result) {
      this.toastrService.success("Producto agregado al carrito", "Ok");
      this.router.navigate(["/inicio"]);
    } else {
      this.toastrService.warning(
        "No se pudo agregar el producto al carrito intenta nuevamente",
        "Cuidado!"
      );
    }
  }

  validateCheckModifiers(category: any, modifier: any) {
    if (category.maxSeleccionado == 1) {
      category.modificadores.forEach((modificador) => {
        modificador.seleccionado = false;
      });
      modifier.seleccionado = true;
    }
    if (category.minSeleccionado == 1) {
      let noSelect: number = 1;
      category.modificadores.forEach((modificador) => {
        if (modificador.seleccionado == false) {
          noSelect++;
        }
      });
      if (noSelect == category.modificadores.length) {
        modifier.seleccionado = true;
      }
    }
    if (category.maxSeleccionado > 1) {
      let countSelect: number = 0;
      category.modificadores.forEach((modificador) => {
        if (modificador.seleccionado == true) {
          countSelect++;
        }
      });

      if (countSelect > category.maxSeleccionado) {
        modifier.seleccionado = false;
      }
    }
    this.cartService.saveProduct(this.product);
    this.product = this.cartService.getProduct();
  }

  back(codCategoria) {

    if (this.typeMenu > 1) {
      this.router.navigate(["/inicio/"+ codCategoria]);
    } else {
      this.router.navigate(["/categoria/" + codCategoria]);
    }
  }
}
